/** Textes de l’espace /network. L’anglais sert de repli aux langues sans entrée. */
const menuFlags = {
  fr: {
    'network.menuFlag.institution_panel': 'Menu : Panneau établissement',
    'network.menuFlag.webinars_enterprise': 'Webinaires entreprise',
    'network.menuFlag.rh_campaigns': 'Campagnes formation',
    'network.menuFlag.rh_codir': 'CODIR (DRH)',
    'network.menuFlag.rh_competencies': 'Compétences',
    'network.menuFlag.rh_requests': 'Demandes / workflows',
    'network.menuFlag.rh_catalog': 'Catalogue formation',
    'network.menuFlag.integrations_page': 'Page Intégrations',
    'network.menuFlag.tab_webinar_settings': 'Onglet : Paramètres webinaires',
    'network.menuFlag.tab_rh_dashboard': 'Onglet : Pilotage RH',
    'network.menuFlag.tab_infpc': 'Onglet : INFPC (cofinancement)',
    'network.menuFlag.tab_flows': 'Onglet : Parcours EduFlow',
    'network.menuFlag.tab_trash': 'Onglet : Corbeille',
    'network.menuFlag.tab_supports': 'Onglet : Supports',
    'network.menuFlag.tab_categories': 'Onglet : Catégories',
    'network.menuFlag.tab_templates': 'Onglet : Modèles de blocs',
    'network.menuFlag.tab_content_pipeline': 'Onglet : Pipeline contenu',
    'network.menuFlag.tab_designers': 'Onglet : Concepteurs',
    'network.menuFlag.tab_learners': 'Onglet : Apprenants',
    'network.menuFlag.tab_learner_analytics': 'Onglet : Analytics apprenants',
    'network.menuFlag.tab_bi_studio': 'Onglet : Tableaux BI',
    'network.menuFlag.tab_classes': 'Onglet : Classes',
    'network.menuFlag.tab_evaluations': 'Onglet : Évaluations',
    'network.menuFlag.tab_training_sessions': 'Onglet : Sessions (séances de cours)',
    'network.menuFlag.learner_public_formations_education': 'Éducation : « Formations publiques » visibles par les élèves',
    'network.menuFlag.tab_groups': 'Onglet : Groupes',
    'network.menuFlag.tab_services': 'Onglet : Services entreprise',
    'network.menuFlag.tab_branding': 'Onglet : Charte graphique',
    'network.menuFlag.tab_landing': 'Onglet : Page d’accueil portail',
    'network.menuFlag.tab_webhooks': 'Onglet : Webhooks',
    'network.menuFlag.tab_scorm': 'Onglet : SCORM',
    'network.menuFlag.tab_xapi': 'Onglet : xAPI',
    'network.menuFlag.tab_mcp': 'Onglet : MCP',
    'network.menuFlag.tab_sirh': 'Onglet : SIRH',
  },
  en: {
    'network.menuFlag.institution_panel': 'Menu: Institution panel',
    'network.menuFlag.webinars_enterprise': 'Enterprise webinars',
    'network.menuFlag.rh_campaigns': 'Training campaigns',
    'network.menuFlag.rh_codir': 'Executive committee (HR director)',
    'network.menuFlag.rh_competencies': 'Competencies',
    'network.menuFlag.rh_requests': 'Requests / workflows',
    'network.menuFlag.rh_catalog': 'Training catalog',
    'network.menuFlag.integrations_page': 'Integrations page',
    'network.menuFlag.tab_webinar_settings': 'Tab: Webinar settings',
    'network.menuFlag.tab_rh_dashboard': 'Tab: HR steering',
    'network.menuFlag.tab_infpc': 'Tab: INFPC (co-funding)',
    'network.menuFlag.tab_flows': 'Tab: EduFlow paths',
    'network.menuFlag.tab_trash': 'Tab: Trash',
    'network.menuFlag.tab_supports': 'Tab: Materials',
    'network.menuFlag.tab_categories': 'Tab: Categories',
    'network.menuFlag.tab_templates': 'Tab: Block templates',
    'network.menuFlag.tab_content_pipeline': 'Tab: Content pipeline',
    'network.menuFlag.tab_designers': 'Tab: Designers',
    'network.menuFlag.tab_learners': 'Tab: Learners',
    'network.menuFlag.tab_learner_analytics': 'Tab: Learner analytics',
    'network.menuFlag.tab_bi_studio': 'Tab: BI dashboards',
    'network.menuFlag.tab_classes': 'Tab: Classes',
    'network.menuFlag.tab_evaluations': 'Tab: Evaluations',
    'network.menuFlag.tab_training_sessions': 'Tab: Sessions (class sessions)',
    'network.menuFlag.learner_public_formations_education': 'Education: “Public courses” visible to students',
    'network.menuFlag.tab_groups': 'Tab: Groups',
    'network.menuFlag.tab_services': 'Tab: Enterprise services',
    'network.menuFlag.tab_branding': 'Tab: Branding',
    'network.menuFlag.tab_landing': 'Tab: Portal home page',
    'network.menuFlag.tab_webhooks': 'Tab: Webhooks',
    'network.menuFlag.tab_scorm': 'Tab: SCORM',
    'network.menuFlag.tab_xapi': 'Tab: xAPI',
    'network.menuFlag.tab_mcp': 'Tab: MCP',
    'network.menuFlag.tab_sirh': 'Tab: HRIS',
  },
} as const;

type Pack = Record<string, string>;

const fr: Pack = {
  'network.brand': 'Multi-site',
  'network.header': 'Espace multi-site',
  'network.headerSubtitle': 'Établissements, comptes et collaborateurs',
  'network.nav.home': 'Accueil',
  'network.nav.stats': 'Statistiques',
  'network.nav.establishments': 'Établissements',
  'network.nav.formations': 'Formations',
  'network.nav.accounts': 'Comptes',
  'network.nav.collapse': 'Réduire',
  'network.loadError': 'Impossible de charger le multi-site.',
  'network.home.lead': 'Vue d’ensemble de tous les établissements : apprenants, inscriptions, formations et activité.',
  'network.home.formationsHint': '{{published}} publiées sur {{total}}',
  'network.home.openStats': 'Voir le détail des apprenants',
  'network.kpi.establishments': 'Établissements',
  'network.kpi.collaborators': 'Collaborateurs',
  'network.kpi.learners': 'Apprenants',
  'network.kpi.formations': 'Formations',
  'network.kpi.formationsHint': 'Consulter et rendre visibles',
  'network.establishments.title': 'Établissements',
  'network.establishments.meta': '{{sites}} établissement(s) · {{accounts}} compte(s)',
  'network.establishments.create': 'Nouvel établissement',
  'network.establishments.seat': 'Siège',
  'network.establishments.accountCount': '{{count}} comptes',
  'network.establishments.openAccounts': 'Comptes',
  'network.establishments.remove': 'Retirer',
  'network.establishments.empty': 'Aucun établissement rattaché.',
  'network.accounts.title': 'Comptes et collaborateurs',
  'network.accounts.lead': 'Tous les comptes des établissements du multi-site : administrateurs, RH, formateurs, managers, responsables formation et apprenants.',
  'network.accounts.search': 'Rechercher un nom ou un e-mail',
  'network.accounts.allSites': 'Tous les établissements',
  'network.accounts.name': 'Nom',
  'network.accounts.email': 'E-mail',
  'network.accounts.role': 'Rôle',
  'network.accounts.site': 'Établissement',
  'network.accounts.empty': 'Aucun compte.',
  'network.create.title': 'Créer un établissement',
  'network.create.lead': 'Même fiche que dans l’administration, sans les informations légales. L’établissement et son compte administrateur sont rattachés à ce multi-site.',
  'network.create.menusTitle': 'Menus du dashboard établissement',
  'network.create.menusHint': 'Cochez ou décochez chaque entrée : les menus latéraux et l’espace établissement se mettent à jour.',
  'network.create.paletteTitle': 'Palette du designer EduFlow',
  'network.create.paletteHint': 'Décochez un type de bloc pour le retirer du menu latéral du designer pour cet établissement.',
  'network.create.general': 'Informations générales',
  'network.create.name': 'Nom',
  'network.create.email': 'E-mail institution',
  'network.create.description': 'Description',
  'network.create.verified': 'Compte vérifié',
  'network.create.published': 'Portail publié',
  'network.create.addressTitle': 'Adresse',
  'network.create.address': 'Adresse',
  'network.create.address2': 'Complément',
  'network.create.city': 'Ville',
  'network.create.region': 'Région / département',
  'network.create.postal': 'Code postal',
  'network.create.country': 'Pays',
  'network.create.portalTitle': 'Portail et identité',
  'network.create.slug': 'Sous-domaine (slug)',
  'network.create.slugPlaceholder': 'ex. acme-formation',
  'network.create.qualiopiTitle': 'Qualiopi et OPCO',
  'network.create.qualiopi': 'Organisme certifié Qualiopi',
  'network.create.opcoName': 'OPCO (nom)',
  'network.create.opcoCode': 'OPCO (code)',
  'network.create.cancel': 'Annuler',
  'network.create.submit': 'Créer',
  'network.create.required': 'Nom, slug et e-mail administrateur sont requis.',
  'network.create.slugInvalid': 'Le slug doit contenir uniquement des lettres minuscules, chiffres et tirets.',
  'network.create.error': 'Création impossible.',
  'network.remove.title': 'Retirer cet établissement ?',
  'network.remove.body': '{{name}} ne fera plus partie de ce multi-site. Le compte de l’établissement reste actif.',
  'network.remove.confirm': 'Retirer',
  'network.remove.error': 'Retrait impossible.',
  'network.created.title': 'Établissement créé',
  'network.created.body': '{{name}} a été créé avec un utilisateur administrateur.',
  'network.created.email': 'E-mail admin',
  'network.created.password': 'Mot de passe temporaire',
  'network.created.close': 'Fermer',
  'network.menuSection.nav': 'Navigation et modules Formation / RH',
  'network.menuSection.general': 'Onglets établissement — Général',
  'network.menuSection.content': 'Onglets — Contenu et formations',
  'network.menuSection.people': 'Onglets — Équipes et apprenants',
  'network.menuSection.portal': 'Onglets — Portail et image',
  'network.menuSection.integrations': 'Onglets — Intégrations',
  'network.menuSection.other': 'Autres',
  'network.formations.title': 'Formations',
  'network.formations.lead': 'Toutes les formations des établissements du multi-site, en lecture seule. Vous pouvez les rendre visibles à d’autres établissements, qui ne pourront pas les modifier.',
  'network.formations.search': 'Rechercher une formation ou un établissement…',
  'network.formations.all': 'Tous les établissements',
  'network.formations.empty': 'Aucune formation.',
  'network.formations.loadError': 'Impossible de charger les formations.',
  'network.formations.saveError': 'Enregistrement impossible.',
  'network.formations.status.draft': 'Brouillon',
  'network.formations.status.published': 'Publiée',
  'network.formations.status.archived': 'Archivée',
  'network.formations.visibleFor': 'Visible pour {{names}}',
  'network.formations.view': 'Consulter',
  'network.formations.share': 'Rendre visible',
  'network.formations.shareTitle': 'Rendre visible',
  'network.formations.shareLead': '{{title}} — les établissements cochés pourront consulter cette formation, sans la modifier.',
  'network.formations.shareEmpty': 'Aucun autre établissement dans ce multi-site.',
  'network.formations.cancel': 'Annuler',
  'network.formations.save': 'Enregistrer',
  'network.formations.saving': 'Enregistrement…',
  'network.stats.title': 'Statistiques apprenants',
  'network.stats.lead': 'Indicateurs agrégés de tous les sites. La liste n’affiche que 25 apprenants à la fois.',
  'network.stats.period': 'Période d’inscription',
  'network.stats.period.all': 'Toute la période',
  'network.stats.period.7': '7 jours',
  'network.stats.period.30': '30 jours',
  'network.stats.period.90': '90 jours',
  'network.stats.period.365': '12 mois',
  'network.stats.period.custom': 'Personnalisée',
  'network.stats.status': 'Statut',
  'network.stats.status.all': 'Tous les statuts',
  'network.stats.status.active': 'Actifs (30 jours)',
  'network.stats.status.inactive': 'Inactifs',
  'network.stats.status.completed': 'Parcours terminés',
  'network.stats.status.none': 'Sans inscription',
  'network.stats.status.short.active': 'Actif',
  'network.stats.status.short.inactive': 'Inactif',
  'network.stats.status.short.completed': 'Terminé',
  'network.stats.status.short.none': 'Sans inscription',
  'network.stats.flow': 'Formation',
  'network.stats.flow.all': 'Toutes les formations',
  'network.stats.learnerSearch': 'Recherche apprenant',
  'network.stats.learnerSearchPlaceholder': 'Nom ou e-mail (2 caractères min.)',
  'network.stats.from': 'Du',
  'network.stats.to': 'Au',
  'network.stats.sites': 'Établissements',
  'network.stats.allSites': 'Tous les sites',
  'network.stats.flowFilter': 'Filtrer la liste des formations',
  'network.stats.flowFilterPlaceholder': 'Titre de formation',
  'network.stats.loadError': 'Chargement impossible.',
  'network.stats.kpi.learners': 'Apprenants',
  'network.stats.kpi.learnersHint': '{{newCount}} nouveaux · {{percent}} %',
  'network.stats.kpi.activeInactive': 'Actifs / inactifs',
  'network.stats.kpi.activeHint': '{{completed}} terminés · {{none}} sans inscription',
  'network.stats.kpi.enrollments': 'Inscriptions',
  'network.stats.kpi.enrollmentsHint': '{{completed}} terminées · {{rate}} %',
  'network.stats.kpi.time': 'Temps de formation',
  'network.stats.kpi.timeHint': 'Moyenne {{avg}} / inscription',
  'network.stats.kpi.notStarted': 'Non commencées',
  'network.stats.kpi.notStartedHint': 'Inscriptions sans démarrage',
  'network.stats.kpi.stalled': 'En pause',
  'network.stats.kpi.stalledHint': 'Commencées, sans activité depuis 30 jours',
  'network.stats.kpi.published': 'Formations publiées',
  'network.stats.kpi.publishedHint': 'Sur les sites filtrés',
  'network.stats.kpi.sites': 'Sites',
  'network.stats.kpi.sitesHint': 'Établissements inclus dans le filtre',
  'network.stats.bySite': 'Par établissement',
  'network.stats.col.site': 'Site',
  'network.stats.col.learners': 'Apprenants',
  'network.stats.col.active': 'Actifs',
  'network.stats.col.enrollments': 'Inscriptions',
  'network.stats.col.completed': 'Terminées',
  'network.stats.col.rate': 'Taux',
  'network.stats.col.time': 'Temps',
  'network.stats.col.avgTime': 'Temps moyen',
  'network.stats.col.learner': 'Apprenant',
  'network.stats.col.status': 'Statut',
  'network.stats.col.lastAccess': 'Dernière activité',
  'network.stats.col.flow': 'Formation',
  'network.stats.emptyFilters': 'Aucun apprenant pour ces filtres.',
  'network.stats.progress': 'Répartition de la progression',
  'network.stats.progress.none': 'Sans inscription',
  'network.stats.activity': 'Activité des 12 dernières semaines',
  'network.stats.activityDone': '{{count}} fin',
  'network.stats.topFlows': 'Formations les plus suivies',
  'network.stats.noEnrollments': 'Aucune inscription.',
  'network.stats.learners': 'Apprenants',
  'network.stats.total': '{{count}} au total',
  'network.stats.noLearners': 'Aucun apprenant.',
  'network.stats.page': 'Page {{page}} / {{total}}',
  'network.stats.prev': 'Précédent',
  'network.stats.next': 'Suivant',
  'network.duration.zero': '0 min',
  'network.duration.minutes': '{{minutes}} min',
  'network.duration.hours': '{{hours}} h {{minutes}} min',
  'network.role.admin': 'Admin plateforme',
  'network.role.teacher': 'Formateur',
  'network.role.institution_admin': 'Admin établissement',
  'network.role.drh': 'DRH',
  'network.role.rh': 'RH',
  'network.role.resp_formation': 'Responsable formation',
  'network.role.manager': 'Manager',
  'network.role.collaborateur': 'Collaborateur',
  'network.role.student': 'Apprenant',
  'network.role.editor': 'Éditeur',
  'network.role.network': 'Compte réseau',
  'network.role.account': 'Compte',
  'network.stats.progress.b0_25': '0–25 %',
  'network.stats.progress.b26_50': '26–50 %',
  'network.stats.progress.b51_75': '51–75 %',
  'network.stats.progress.b76_100': '76–100 %',
};

const en: Pack = {
  'network.brand': 'Multi-site',
  'network.header': 'Multi-site area',
  'network.headerSubtitle': 'Establishments, accounts and staff',
  'network.nav.home': 'Home',
  'network.nav.stats': 'Statistics',
  'network.nav.establishments': 'Establishments',
  'network.nav.formations': 'Trainings',
  'network.nav.accounts': 'Accounts',
  'network.nav.collapse': 'Collapse',
  'network.loadError': 'Unable to load the multi-site area.',
  'network.home.lead': 'Overview of every establishment: learners, enrollments, trainings and activity.',
  'network.home.formationsHint': '{{published}} published out of {{total}}',
  'network.home.openStats': 'Open learner details',
  'network.kpi.establishments': 'Establishments',
  'network.kpi.collaborators': 'Staff',
  'network.kpi.learners': 'Learners',
  'network.kpi.formations': 'Trainings',
  'network.kpi.formationsHint': 'View and share visibility',
  'network.establishments.title': 'Establishments',
  'network.establishments.meta': '{{sites}} establishment(s) · {{accounts}} account(s)',
  'network.establishments.create': 'New establishment',
  'network.establishments.seat': 'Headquarters',
  'network.establishments.accountCount': '{{count}} accounts',
  'network.establishments.openAccounts': 'Accounts',
  'network.establishments.remove': 'Remove',
  'network.establishments.empty': 'No establishment linked yet.',
  'network.accounts.title': 'Accounts and staff',
  'network.accounts.lead': 'Every account across the multi-site establishments: administrators, HR, trainers, managers, training leads and learners.',
  'network.accounts.search': 'Search a name or email',
  'network.accounts.allSites': 'All establishments',
  'network.accounts.name': 'Name',
  'network.accounts.email': 'Email',
  'network.accounts.role': 'Role',
  'network.accounts.site': 'Establishment',
  'network.accounts.empty': 'No account.',
  'network.create.title': 'Create an establishment',
  'network.create.lead': 'Same form as in administration, without legal details. The establishment and its admin account are attached to this multi-site.',
  'network.create.menusTitle': 'Establishment dashboard menus',
  'network.create.menusHint': 'Toggle each entry: side menus and the establishment area update for this site.',
  'network.create.paletteTitle': 'EduFlow designer palette',
  'network.create.paletteHint': 'Uncheck a block type to hide it from the designer side menu for this establishment.',
  'network.create.general': 'General information',
  'network.create.name': 'Name',
  'network.create.email': 'Institution email',
  'network.create.description': 'Description',
  'network.create.verified': 'Verified account',
  'network.create.published': 'Published portal',
  'network.create.addressTitle': 'Address',
  'network.create.address': 'Address',
  'network.create.address2': 'Address line 2',
  'network.create.city': 'City',
  'network.create.region': 'Region',
  'network.create.postal': 'Postal code',
  'network.create.country': 'Country',
  'network.create.portalTitle': 'Portal and identity',
  'network.create.slug': 'Subdomain (slug)',
  'network.create.slugPlaceholder': 'e.g. acme-training',
  'network.create.qualiopiTitle': 'Qualiopi and OPCO',
  'network.create.qualiopi': 'Qualiopi-certified organization',
  'network.create.opcoName': 'OPCO (name)',
  'network.create.opcoCode': 'OPCO (code)',
  'network.create.cancel': 'Cancel',
  'network.create.submit': 'Create',
  'network.create.required': 'Name, slug and administrator email are required.',
  'network.create.slugInvalid': 'The slug may only contain lowercase letters, digits and hyphens.',
  'network.create.error': 'Could not create the establishment.',
  'network.remove.title': 'Remove this establishment?',
  'network.remove.body': '{{name}} will leave this multi-site. The establishment account stays active.',
  'network.remove.confirm': 'Remove',
  'network.remove.error': 'Could not remove the establishment.',
  'network.created.title': 'Establishment created',
  'network.created.body': '{{name}} was created with an administrator user.',
  'network.created.email': 'Admin email',
  'network.created.password': 'Temporary password',
  'network.created.close': 'Close',
  'network.menuSection.nav': 'Navigation and training / HR modules',
  'network.menuSection.general': 'Establishment tabs — General',
  'network.menuSection.content': 'Tabs — Content and trainings',
  'network.menuSection.people': 'Tabs — Teams and learners',
  'network.menuSection.portal': 'Tabs — Portal and branding',
  'network.menuSection.integrations': 'Tabs — Integrations',
  'network.menuSection.other': 'Other',
  'network.formations.title': 'Trainings',
  'network.formations.lead': 'Every training in the multi-site establishments, read-only. You can make them visible to other establishments, which cannot edit them.',
  'network.formations.search': 'Search a training or an establishment…',
  'network.formations.all': 'All establishments',
  'network.formations.empty': 'No training.',
  'network.formations.loadError': 'Unable to load trainings.',
  'network.formations.saveError': 'Could not save.',
  'network.formations.status.draft': 'Draft',
  'network.formations.status.published': 'Published',
  'network.formations.status.archived': 'Archived',
  'network.formations.visibleFor': 'Visible to {{names}}',
  'network.formations.view': 'View',
  'network.formations.share': 'Share visibility',
  'network.formations.shareTitle': 'Share visibility',
  'network.formations.shareLead': '{{title}} — checked establishments can view this training, but not edit it.',
  'network.formations.shareEmpty': 'No other establishment in this multi-site.',
  'network.formations.cancel': 'Cancel',
  'network.formations.save': 'Save',
  'network.formations.saving': 'Saving…',
  'network.stats.title': 'Learner statistics',
  'network.stats.lead': 'Aggregated indicators for every site. The list shows 25 learners at a time.',
  'network.stats.period': 'Registration period',
  'network.stats.period.all': 'All time',
  'network.stats.period.7': '7 days',
  'network.stats.period.30': '30 days',
  'network.stats.period.90': '90 days',
  'network.stats.period.365': '12 months',
  'network.stats.period.custom': 'Custom',
  'network.stats.status': 'Status',
  'network.stats.status.all': 'All statuses',
  'network.stats.status.active': 'Active (30 days)',
  'network.stats.status.inactive': 'Inactive',
  'network.stats.status.completed': 'Paths completed',
  'network.stats.status.none': 'Not enrolled',
  'network.stats.status.short.active': 'Active',
  'network.stats.status.short.inactive': 'Inactive',
  'network.stats.status.short.completed': 'Completed',
  'network.stats.status.short.none': 'Not enrolled',
  'network.stats.flow': 'Training',
  'network.stats.flow.all': 'All trainings',
  'network.stats.learnerSearch': 'Learner search',
  'network.stats.learnerSearchPlaceholder': 'Name or email (2 characters min.)',
  'network.stats.from': 'From',
  'network.stats.to': 'To',
  'network.stats.sites': 'Establishments',
  'network.stats.allSites': 'All sites',
  'network.stats.flowFilter': 'Filter the training list',
  'network.stats.flowFilterPlaceholder': 'Training title',
  'network.stats.loadError': 'Unable to load.',
  'network.stats.kpi.learners': 'Learners',
  'network.stats.kpi.learnersHint': '{{newCount}} new · {{percent}}%',
  'network.stats.kpi.activeInactive': 'Active / inactive',
  'network.stats.kpi.activeHint': '{{completed}} completed · {{none}} not enrolled',
  'network.stats.kpi.enrollments': 'Enrollments',
  'network.stats.kpi.enrollmentsHint': '{{completed}} completed · {{rate}}%',
  'network.stats.kpi.time': 'Training time',
  'network.stats.kpi.timeHint': 'Average {{avg}} / enrollment',
  'network.stats.kpi.notStarted': 'Not started',
  'network.stats.kpi.notStartedHint': 'Enrollments never started',
  'network.stats.kpi.stalled': 'Paused',
  'network.stats.kpi.stalledHint': 'Started, with no activity for 30 days',
  'network.stats.kpi.published': 'Published trainings',
  'network.stats.kpi.publishedHint': 'On the filtered sites',
  'network.stats.kpi.sites': 'Sites',
  'network.stats.kpi.sitesHint': 'Establishments included in the filter',
  'network.stats.bySite': 'By establishment',
  'network.stats.col.site': 'Site',
  'network.stats.col.learners': 'Learners',
  'network.stats.col.active': 'Active',
  'network.stats.col.enrollments': 'Enrollments',
  'network.stats.col.completed': 'Completed',
  'network.stats.col.rate': 'Rate',
  'network.stats.col.time': 'Time',
  'network.stats.col.avgTime': 'Average time',
  'network.stats.col.learner': 'Learner',
  'network.stats.col.status': 'Status',
  'network.stats.col.lastAccess': 'Last activity',
  'network.stats.col.flow': 'Training',
  'network.stats.emptyFilters': 'No learner matches these filters.',
  'network.stats.progress': 'Progress distribution',
  'network.stats.progress.none': 'Not enrolled',
  'network.stats.activity': 'Activity over the last 12 weeks',
  'network.stats.activityDone': '{{count}} done',
  'network.stats.topFlows': 'Most followed trainings',
  'network.stats.noEnrollments': 'No enrollment.',
  'network.stats.learners': 'Learners',
  'network.stats.total': '{{count}} in total',
  'network.stats.noLearners': 'No learner.',
  'network.stats.page': 'Page {{page}} / {{total}}',
  'network.stats.prev': 'Previous',
  'network.stats.next': 'Next',
  'network.duration.zero': '0 min',
  'network.duration.minutes': '{{minutes}} min',
  'network.duration.hours': '{{hours}} h {{minutes}} min',
  'network.role.admin': 'Platform admin',
  'network.role.teacher': 'Trainer',
  'network.role.institution_admin': 'Establishment admin',
  'network.role.drh': 'HR director',
  'network.role.rh': 'HR',
  'network.role.resp_formation': 'Training lead',
  'network.role.manager': 'Manager',
  'network.role.collaborateur': 'Staff member',
  'network.role.student': 'Learner',
  'network.role.editor': 'Editor',
  'network.role.network': 'Network account',
  'network.role.account': 'Account',
  'network.stats.progress.b0_25': '0–25%',
  'network.stats.progress.b26_50': '26–50%',
  'network.stats.progress.b51_75': '51–75%',
  'network.stats.progress.b76_100': '76–100%',
};

function pack(overrides: Pack): Pack {
  return { ...en, ...overrides };
}

export const networkStrings: Record<string, Pack> = {
  fr: { ...fr, ...menuFlags.fr },
  en: { ...en, ...menuFlags.en },
  es: pack({
    'network.menuFlag.tab_training_sessions': 'Pestaña: Sesiones (sesiones de clase)',
    'network.menuFlag.learner_public_formations_education': 'Educación: «Formaciones públicas» visibles para los alumnos',
    'network.header': 'Espacio multisitio',
    'network.headerSubtitle': 'Centros, cuentas y colaboradores',
    'network.nav.home': 'Inicio',
    'network.nav.stats': 'Estadísticas',
    'network.nav.establishments': 'Centros',
    'network.nav.formations': 'Formaciones',
    'network.nav.accounts': 'Cuentas',
    'network.nav.collapse': 'Reducir',
    'network.loadError': 'No se puede cargar el multisitio.',
    'network.home.lead': 'Seguimiento de los centros del multisitio, de sus cuentas y de sus colaboradores.',
    'network.kpi.establishments': 'Centros',
    'network.kpi.collaborators': 'Colaboradores',
    'network.kpi.learners': 'Alumnos',
    'network.kpi.formations': 'Formaciones',
    'network.kpi.formationsHint': 'Consultar y hacer visibles',
    'network.establishments.title': 'Centros',
    'network.establishments.meta': '{{sites}} centro(s) · {{accounts}} cuenta(s)',
    'network.establishments.create': 'Nuevo centro',
    'network.establishments.seat': 'Sede',
    'network.establishments.accountCount': '{{count}} cuentas',
    'network.establishments.openAccounts': 'Cuentas',
    'network.establishments.remove': 'Quitar',
    'network.establishments.empty': 'Ningún centro vinculado.',
    'network.accounts.title': 'Cuentas y colaboradores',
    'network.accounts.lead': 'Todas las cuentas de los centros: administradores, RR. HH., formadores, managers, responsables de formación y alumnos.',
    'network.accounts.search': 'Buscar un nombre o un correo',
    'network.accounts.allSites': 'Todos los centros',
    'network.accounts.name': 'Nombre',
    'network.accounts.email': 'Correo',
    'network.accounts.role': 'Rol',
    'network.accounts.site': 'Centro',
    'network.accounts.empty': 'Ninguna cuenta.',
    'network.create.title': 'Crear un centro',
    'network.create.lead': 'La misma ficha que en la administración, sin datos legales. El centro y su cuenta de administrador quedan vinculados a este multisitio.',
    'network.create.menusTitle': 'Menús del panel del centro',
    'network.create.menusHint': 'Active o desactive cada entrada: los menús y el espacio del centro se actualizan.',
    'network.create.paletteTitle': 'Paleta del diseñador EduFlow',
    'network.create.paletteHint': 'Desmarque un tipo de bloque para ocultarlo del menú del diseñador de este centro.',
    'network.create.general': 'Información general',
    'network.create.name': 'Nombre',
    'network.create.email': 'Correo de la institución',
    'network.create.description': 'Descripción',
    'network.create.verified': 'Cuenta verificada',
    'network.create.published': 'Portal publicado',
    'network.create.addressTitle': 'Dirección',
    'network.create.address': 'Dirección',
    'network.create.address2': 'Complemento',
    'network.create.city': 'Ciudad',
    'network.create.region': 'Región',
    'network.create.postal': 'Código postal',
    'network.create.country': 'País',
    'network.create.portalTitle': 'Portal e identidad',
    'network.create.slug': 'Subdominio (slug)',
    'network.create.slugPlaceholder': 'ej. acme-formacion',
    'network.create.qualiopiTitle': 'Qualiopi y OPCO',
    'network.create.qualiopi': 'Organismo certificado Qualiopi',
    'network.create.cancel': 'Cancelar',
    'network.create.submit': 'Crear',
    'network.create.required': 'El nombre, el slug y el correo del administrador son obligatorios.',
    'network.create.slugInvalid': 'El slug solo puede contener minúsculas, cifras y guiones.',
    'network.create.error': 'No se pudo crear.',
    'network.remove.title': '¿Quitar este centro?',
    'network.remove.body': '{{name}} dejará de formar parte de este multisitio. La cuenta del centro sigue activa.',
    'network.remove.confirm': 'Quitar',
    'network.remove.error': 'No se pudo quitar.',
    'network.created.title': 'Centro creado',
    'network.created.body': '{{name}} se creó con un usuario administrador.',
    'network.created.email': 'Correo admin',
    'network.created.password': 'Contraseña temporal',
    'network.created.close': 'Cerrar',
    'network.formations.title': 'Formaciones',
    'network.formations.lead': 'Todas las formaciones de los centros, en solo lectura. Puede hacerlas visibles para otros centros, que no podrán modificarlas.',
    'network.formations.search': 'Buscar una formación o un centro…',
    'network.formations.all': 'Todos los centros',
    'network.formations.empty': 'Ninguna formación.',
    'network.formations.loadError': 'No se pueden cargar las formaciones.',
    'network.formations.saveError': 'No se pudo guardar.',
    'network.formations.status.draft': 'Borrador',
    'network.formations.status.published': 'Publicada',
    'network.formations.status.archived': 'Archivada',
    'network.formations.visibleFor': 'Visible para {{names}}',
    'network.formations.view': 'Consultar',
    'network.formations.share': 'Hacer visible',
    'network.formations.shareTitle': 'Hacer visible',
    'network.formations.shareLead': '{{title}} — los centros marcados podrán consultar esta formación, sin modificarla.',
    'network.formations.shareEmpty': 'No hay otro centro en este multisitio.',
    'network.formations.cancel': 'Cancelar',
    'network.formations.save': 'Guardar',
    'network.formations.saving': 'Guardando…',
    'network.stats.title': 'Estadísticas de alumnos',
    'network.stats.lead': 'Indicadores agregados de todos los sitios. La lista muestra 25 alumnos a la vez.',
    'network.stats.period': 'Periodo de inscripción',
    'network.stats.period.all': 'Todo el periodo',
    'network.stats.period.7': '7 días',
    'network.stats.period.30': '30 días',
    'network.stats.period.90': '90 días',
    'network.stats.period.365': '12 meses',
    'network.stats.period.custom': 'Personalizado',
    'network.stats.status': 'Estado',
    'network.stats.status.all': 'Todos los estados',
    'network.stats.status.active': 'Activos (30 días)',
    'network.stats.status.inactive': 'Inactivos',
    'network.stats.status.completed': 'Recorridos terminados',
    'network.stats.status.none': 'Sin inscripción',
    'network.stats.status.short.active': 'Activo',
    'network.stats.status.short.inactive': 'Inactivo',
    'network.stats.status.short.completed': 'Terminado',
    'network.stats.status.short.none': 'Sin inscripción',
    'network.stats.flow': 'Formación',
    'network.stats.flow.all': 'Todas las formaciones',
    'network.stats.learnerSearch': 'Buscar alumno',
    'network.stats.learnerSearchPlaceholder': 'Nombre o correo (mín. 2 caracteres)',
    'network.stats.from': 'Desde',
    'network.stats.to': 'Hasta',
    'network.stats.sites': 'Centros',
    'network.stats.allSites': 'Todos los sitios',
    'network.stats.flowFilter': 'Filtrar la lista de formaciones',
    'network.stats.flowFilterPlaceholder': 'Título de la formación',
    'network.stats.loadError': 'No se puede cargar.',
    'network.stats.kpi.learners': 'Alumnos',
    'network.stats.kpi.learnersHint': '{{newCount}} nuevos · {{percent}} %',
    'network.stats.kpi.activeInactive': 'Activos / inactivos',
    'network.stats.kpi.activeHint': '{{completed}} terminados · {{none}} sin inscripción',
    'network.stats.kpi.enrollments': 'Inscripciones',
    'network.stats.kpi.enrollmentsHint': '{{completed}} terminadas · {{rate}} %',
    'network.stats.kpi.time': 'Tiempo de formación',
    'network.stats.kpi.timeHint': 'Media {{avg}} / inscripción',
    'network.stats.kpi.notStarted': 'No empezadas',
    'network.stats.kpi.notStartedHint': 'Inscripciones sin inicio',
    'network.stats.kpi.stalled': 'En pausa',
    'network.stats.kpi.stalledHint': 'Empezadas, sin actividad desde hace 30 días',
    'network.stats.kpi.published': 'Formaciones publicadas',
    'network.stats.kpi.publishedHint': 'En los sitios filtrados',
    'network.stats.kpi.sites': 'Sitios',
    'network.stats.kpi.sitesHint': 'Centros incluidos en el filtro',
    'network.stats.bySite': 'Por centro',
    'network.stats.col.site': 'Sitio',
    'network.stats.col.learners': 'Alumnos',
    'network.stats.col.active': 'Activos',
    'network.stats.col.enrollments': 'Inscripciones',
    'network.stats.col.completed': 'Terminadas',
    'network.stats.col.rate': 'Tasa',
    'network.stats.col.time': 'Tiempo',
    'network.stats.col.avgTime': 'Tiempo medio',
    'network.stats.col.learner': 'Alumno',
    'network.stats.col.status': 'Estado',
    'network.stats.col.lastAccess': 'Última actividad',
    'network.stats.col.flow': 'Formación',
    'network.stats.emptyFilters': 'Ningún alumno para estos filtros.',
    'network.stats.progress': 'Distribución del progreso',
    'network.stats.progress.none': 'Sin inscripción',
    'network.stats.activity': 'Actividad de las últimas 12 semanas',
    'network.stats.activityDone': '{{count}} fin',
    'network.stats.topFlows': 'Formaciones más seguidas',
    'network.stats.noEnrollments': 'Ninguna inscripción.',
    'network.stats.learners': 'Alumnos',
    'network.stats.total': '{{count}} en total',
    'network.stats.noLearners': 'Ningún alumno.',
    'network.stats.page': 'Página {{page}} / {{total}}',
    'network.stats.prev': 'Anterior',
    'network.stats.next': 'Siguiente',
    'network.menuSection.nav': 'Navegación y módulos Formación / RR. HH.',
    'network.menuSection.general': 'Pestañas del centro — General',
    'network.menuSection.content': 'Pestañas — Contenido y formaciones',
    'network.menuSection.people': 'Pestañas — Equipos y alumnos',
    'network.menuSection.portal': 'Pestañas — Portal e imagen',
    'network.menuSection.integrations': 'Pestañas — Integraciones',
    'network.menuSection.other': 'Otros',
  }),
  de: pack({
    'network.menuFlag.tab_training_sessions': 'Reiter: Sitzungen (Unterrichtsstunden)',
    'network.menuFlag.learner_public_formations_education': 'Bildung: „Öffentliche Schulungen“ für Schüler sichtbar',
    'network.header': 'Multistandort-Bereich',
    'network.headerSubtitle': 'Standorte, Konten und Mitarbeitende',
    'network.nav.home': 'Start',
    'network.nav.stats': 'Statistiken',
    'network.nav.establishments': 'Standorte',
    'network.nav.formations': 'Schulungen',
    'network.nav.accounts': 'Konten',
    'network.nav.collapse': 'Einklappen',
    'network.loadError': 'Der Multistandort konnte nicht geladen werden.',
    'network.home.lead': 'Steuerung aller Standorte, ihrer Konten und ihrer Mitarbeitenden.',
    'network.kpi.establishments': 'Standorte',
    'network.kpi.collaborators': 'Mitarbeitende',
    'network.kpi.learners': 'Lernende',
    'network.kpi.formations': 'Schulungen',
    'network.kpi.formationsHint': 'Ansehen und sichtbar machen',
    'network.establishments.title': 'Standorte',
    'network.establishments.meta': '{{sites}} Standort(e) · {{accounts}} Konto/Konten',
    'network.establishments.create': 'Neuer Standort',
    'network.establishments.seat': 'Sitz',
    'network.establishments.accountCount': '{{count}} Konten',
    'network.establishments.openAccounts': 'Konten',
    'network.establishments.remove': 'Entfernen',
    'network.establishments.empty': 'Kein Standort verknüpft.',
    'network.accounts.title': 'Konten und Mitarbeitende',
    'network.accounts.lead': 'Alle Konten der Standorte: Admins, Personal, Trainer, Manager, Schulungsverantwortliche und Lernende.',
    'network.accounts.search': 'Name oder E-Mail suchen',
    'network.accounts.allSites': 'Alle Standorte',
    'network.accounts.name': 'Name',
    'network.accounts.email': 'E-Mail',
    'network.accounts.role': 'Rolle',
    'network.accounts.site': 'Standort',
    'network.accounts.empty': 'Kein Konto.',
    'network.create.title': 'Standort erstellen',
    'network.create.submit': 'Erstellen',
    'network.create.cancel': 'Abbrechen',
    'network.remove.title': 'Diesen Standort entfernen?',
    'network.remove.confirm': 'Entfernen',
    'network.created.title': 'Standort erstellt',
    'network.created.close': 'Schließen',
    'network.formations.title': 'Schulungen',
    'network.formations.view': 'Ansehen',
    'network.formations.share': 'Sichtbar machen',
    'network.formations.save': 'Speichern',
    'network.formations.cancel': 'Abbrechen',
    'network.stats.title': 'Lernendenstatistiken',
    'network.stats.period': 'Anmeldezeitraum',
    'network.stats.period.all': 'Gesamter Zeitraum',
    'network.stats.status': 'Status',
    'network.stats.status.all': 'Alle Status',
    'network.stats.flow': 'Schulung',
    'network.stats.flow.all': 'Alle Schulungen',
    'network.stats.allSites': 'Alle Standorte',
    'network.stats.learners': 'Lernende',
    'network.stats.kpi.learners': 'Lernende',
    'network.stats.prev': 'Zurück',
    'network.stats.next': 'Weiter',
    'network.stats.bySite': 'Nach Standort',
    'network.stats.progress': 'Fortschrittsverteilung',
    'network.stats.activity': 'Aktivität der letzten 12 Wochen',
    'network.stats.topFlows': 'Meistgenutzte Schulungen',
  }),
  it: pack({
    'network.menuFlag.tab_training_sessions': 'Scheda: Sessioni (lezioni)',
    'network.menuFlag.learner_public_formations_education': 'Istruzione: «Formazioni pubbliche» visibili agli studenti',
    'network.header': 'Spazio multi-sede',
    'network.headerSubtitle': 'Sedi, account e collaboratori',
    'network.nav.home': 'Home',
    'network.nav.stats': 'Statistiche',
    'network.nav.establishments': 'Sedi',
    'network.nav.formations': 'Formazioni',
    'network.nav.accounts': 'Account',
    'network.nav.collapse': 'Riduci',
    'network.kpi.establishments': 'Sedi',
    'network.kpi.collaborators': 'Collaboratori',
    'network.kpi.learners': 'Corsisti',
    'network.kpi.formations': 'Formazioni',
    'network.establishments.title': 'Sedi',
    'network.establishments.create': 'Nuova sede',
    'network.accounts.title': 'Account e collaboratori',
    'network.formations.title': 'Formazioni',
    'network.formations.view': 'Consulta',
    'network.formations.share': 'Rendi visibile',
    'network.stats.title': 'Statistiche corsisti',
    'network.stats.period': 'Periodo di iscrizione',
    'network.stats.status': 'Stato',
    'network.stats.flow': 'Formazione',
    'network.stats.learners': 'Corsisti',
    'network.stats.kpi.learners': 'Corsisti',
    'network.stats.prev': 'Precedente',
    'network.stats.next': 'Successivo',
  }),
  pt: pack({
    'network.menuFlag.tab_training_sessions': 'Separador: Sessões (aulas)',
    'network.menuFlag.learner_public_formations_education': 'Educação: «Formações públicas» visíveis para os alunos',
    'network.header': 'Espaço multi-site',
    'network.headerSubtitle': 'Estabelecimentos, contas e colaboradores',
    'network.nav.home': 'Início',
    'network.nav.stats': 'Estatísticas',
    'network.nav.establishments': 'Estabelecimentos',
    'network.nav.formations': 'Formações',
    'network.nav.accounts': 'Contas',
    'network.nav.collapse': 'Reduzir',
    'network.kpi.establishments': 'Estabelecimentos',
    'network.kpi.collaborators': 'Colaboradores',
    'network.kpi.learners': 'Formandos',
    'network.kpi.formations': 'Formações',
    'network.establishments.title': 'Estabelecimentos',
    'network.establishments.create': 'Novo estabelecimento',
    'network.accounts.title': 'Contas e colaboradores',
    'network.formations.title': 'Formações',
    'network.formations.view': 'Consultar',
    'network.formations.share': 'Tornar visível',
    'network.stats.title': 'Estatísticas dos formandos',
    'network.stats.period': 'Período de inscrição',
    'network.stats.status': 'Estado',
    'network.stats.flow': 'Formação',
    'network.stats.learners': 'Formandos',
    'network.stats.kpi.learners': 'Formandos',
    'network.stats.prev': 'Anterior',
    'network.stats.next': 'Seguinte',
  }),
  lb: pack({
    'network.menuFlag.tab_training_sessions': 'Tab: Sessiounen (Schoulstonnen)',
    'network.menuFlag.learner_public_formations_education': 'Educatioun: „Ëffentlech Formatiounen“ fir d’Schüler siichtbar',
    'network.header': 'Multi-Site-Beräich',
    'network.headerSubtitle': 'Etablissementer, Konten a Mataarbechter',
    'network.nav.home': 'Accueil',
    'network.nav.stats': 'Statistiken',
    'network.nav.establishments': 'Etablissementer',
    'network.nav.formations': 'Formatiounen',
    'network.nav.accounts': 'Konten',
    'network.nav.collapse': 'Reduzéieren',
    'network.kpi.learners': 'Léierender',
    'network.kpi.formations': 'Formatiounen',
    'network.stats.title': 'Statistike vun de Léierender',
    'network.stats.learners': 'Léierender',
    'network.formations.title': 'Formatiounen',
  }),
  uk: pack({
    'network.menuFlag.tab_training_sessions': 'Вкладка: Сесії (уроки)',
    'network.menuFlag.learner_public_formations_education': 'Освіта: «Публічні курси» видимі для учнів',
    'network.header': 'Простір кількох закладів',
    'network.headerSubtitle': 'Заклади, облікові записи та співробітники',
    'network.nav.home': 'Головна',
    'network.nav.stats': 'Статистика',
    'network.nav.establishments': 'Заклади',
    'network.nav.formations': 'Навчання',
    'network.nav.accounts': 'Облікові записи',
    'network.nav.collapse': 'Згорнути',
    'network.kpi.establishments': 'Заклади',
    'network.kpi.collaborators': 'Співробітники',
    'network.kpi.learners': 'Учні',
    'network.kpi.formations': 'Навчання',
    'network.establishments.title': 'Заклади',
    'network.establishments.create': 'Новий заклад',
    'network.accounts.title': 'Облікові записи',
    'network.formations.title': 'Навчання',
    'network.formations.view': 'Переглянути',
    'network.formations.share': 'Зробити видимим',
    'network.stats.title': 'Статистика учнів',
    'network.stats.learners': 'Учні',
    'network.stats.kpi.learners': 'Учні',
    'network.stats.prev': 'Назад',
    'network.stats.next': 'Далі',
    'network.create.cancel': 'Скасувати',
    'network.create.submit': 'Створити',
  }),
  ru: pack({
    'network.menuFlag.tab_training_sessions': 'Вкладка: Сессии (уроки)',
    'network.menuFlag.learner_public_formations_education': 'Образование: «Публичные курсы» видны ученикам',
    'network.header': 'Пространство нескольких площадок',
    'network.headerSubtitle': 'Площадки, учётные записи и сотрудники',
    'network.nav.home': 'Главная',
    'network.nav.stats': 'Статистика',
    'network.nav.establishments': 'Площадки',
    'network.nav.formations': 'Обучения',
    'network.nav.accounts': 'Учётные записи',
    'network.nav.collapse': 'Свернуть',
    'network.kpi.establishments': 'Площадки',
    'network.kpi.collaborators': 'Сотрудники',
    'network.kpi.learners': 'Учащиеся',
    'network.kpi.formations': 'Обучения',
    'network.establishments.title': 'Площадки',
    'network.establishments.create': 'Новая площадка',
    'network.accounts.title': 'Учётные записи',
    'network.formations.title': 'Обучения',
    'network.formations.view': 'Открыть',
    'network.formations.share': 'Сделать видимым',
    'network.stats.title': 'Статистика учащихся',
    'network.stats.learners': 'Учащиеся',
    'network.stats.kpi.learners': 'Учащиеся',
    'network.stats.prev': 'Назад',
    'network.stats.next': 'Далее',
    'network.create.cancel': 'Отмена',
    'network.create.submit': 'Создать',
  }),
  ar: pack({
    'network.menuFlag.tab_training_sessions': 'علامة التبويب: الجلسات (الحصص الدراسية)',
    'network.menuFlag.learner_public_formations_education': 'التعليم: «التكوينات العامة» مرئية للتلاميذ',
    'network.header': 'فضاء المواقع المتعددة',
    'network.headerSubtitle': 'المؤسسات والحسابات والمتعاونون',
    'network.nav.home': 'الرئيسية',
    'network.nav.stats': 'الإحصاءات',
    'network.nav.establishments': 'المؤسسات',
    'network.nav.formations': 'التكوينات',
    'network.nav.accounts': 'الحسابات',
    'network.nav.collapse': 'طي',
    'network.kpi.establishments': 'المؤسسات',
    'network.kpi.collaborators': 'المتعاونون',
    'network.kpi.learners': 'المتعلمون',
    'network.kpi.formations': 'التكوينات',
    'network.establishments.title': 'المؤسسات',
    'network.establishments.create': 'مؤسسة جديدة',
    'network.accounts.title': 'الحسابات والمتعاونون',
    'network.formations.title': 'التكوينات',
    'network.formations.view': 'اطلاع',
    'network.formations.share': 'إظهار',
    'network.stats.title': 'إحصاءات المتعلمين',
    'network.stats.learners': 'المتعلمون',
    'network.stats.kpi.learners': 'المتعلمون',
    'network.stats.prev': 'السابق',
    'network.stats.next': 'التالي',
    'network.create.cancel': 'إلغاء',
    'network.create.submit': 'إنشاء',
    'network.created.close': 'إغلاق',
  }),
  tr: pack({
    'network.menuFlag.tab_training_sessions': 'Sekme: Oturumlar (ders oturumları)',
    'network.menuFlag.learner_public_formations_education': 'Eğitim: “Herkese açık eğitimler” öğrencilere görünür',
    'network.header': 'Çoklu site alanı',
    'network.headerSubtitle': 'Kurumlar, hesaplar ve çalışanlar',
    'network.nav.home': 'Ana sayfa',
    'network.nav.stats': 'İstatistikler',
    'network.nav.establishments': 'Kurumlar',
    'network.nav.formations': 'Eğitimler',
    'network.nav.accounts': 'Hesaplar',
    'network.nav.collapse': 'Daralt',
    'network.kpi.establishments': 'Kurumlar',
    'network.kpi.collaborators': 'Çalışanlar',
    'network.kpi.learners': 'Öğrenenler',
    'network.kpi.formations': 'Eğitimler',
    'network.establishments.title': 'Kurumlar',
    'network.establishments.create': 'Yeni kurum',
    'network.accounts.title': 'Hesaplar ve çalışanlar',
    'network.formations.title': 'Eğitimler',
    'network.formations.view': 'Görüntüle',
    'network.formations.share': 'Görünür yap',
    'network.stats.title': 'Öğrenen istatistikleri',
    'network.stats.learners': 'Öğrenenler',
    'network.stats.kpi.learners': 'Öğrenenler',
    'network.stats.prev': 'Önceki',
    'network.stats.next': 'Sonraki',
    'network.create.cancel': 'İptal',
    'network.create.submit': 'Oluştur',
  }),
};

export const NETWORK_MENU_SECTION_KEY: Record<string, string> = {
  'Navigation & modules Formation / RH': 'network.menuSection.nav',
  'Onglets /institution — Général': 'network.menuSection.general',
  'Onglets — Contenu & formations': 'network.menuSection.content',
  'Onglets — Équipes & apprenants': 'network.menuSection.people',
  'Onglets — Portail & image': 'network.menuSection.portal',
  'Onglets — Intégrations': 'network.menuSection.integrations',
  'Autres (non classés)': 'network.menuSection.other',
};
